import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/Navbar";
import PublicPage from "./pages/PublicPage";
import AdminPage from "./pages/AdminPage";
import ContactPage from "./pages/ContactPage";
import BankOffersPage from "./pages/BankOffersPage";
import HelpPage from "./pages/HelpPage";
import Disclaimers from "./pages/Disclaimers";
import FreeProductsPage from "./pages/FreeProductsPage";
import WebsiteDeals from "./pages/WebsiteDeals";
import WeeklyAds from "./pages/WeeklyAds";
import ProductOfferDetail from "./pages/ProductOfferDetail";
import BankOfferDetail from "./pages/BankOfferDetail";
import Vendors from "./pages/Vendors";
import VendorDetail from "./pages/VendorDetail";
import Footer from "./components/Footer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AffiliateDisclosure from "./pages/AffiliateDisclosure";
import SpecialOfferPage from "./pages/SpecialOfferPage";
import DealExpired from "./pages/DealExpired";
import DollarDealsPage from "./pages/DollarDealsPage";
import TodaysDealsPage from "./pages/TodaysDeals";
import Profile from "./pages/Profile";
import Signup from "./pages/Signup";
import Login from "./pages/Login"; 

// This component listens for route changes and sends page_view events to GA
function GAListener() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-G-YJZN6VZHPH', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null; // This component renders nothing
}

function App() {
  return (
    <Router>
      <GAListener />
      <Navbar />
      <Routes>
        <Route path="/" element={<PublicPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/bank-offers" element={<BankOffersPage />} />
        <Route path="/free-products" element={<FreeProductsPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/disclaimers" element={<Disclaimers />} />
        <Route path="/website-deals" element={<WebsiteDeals />} />
        <Route path="/weekly-ads" element={<WeeklyAds />} />
        <Route path="/product/:productOfferId" element={<ProductOfferDetail />} />
        <Route path="/bankoffer/:bankName/:offerId" element={<BankOfferDetail />} />
        <Route path="/vendors" element={<Vendors />} />
        <Route path="/vendor/:vendorId" element={<VendorDetail />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/disclaimer" element={<AffiliateDisclosure />} />
        <Route path="/special-offers/:offerType" element={<SpecialOfferPage />} />
        <Route path="/deal-expired" element={<DealExpired />} />
        <Route path="/dollar-deals" element={<DollarDealsPage />} />
        <Route path="/todays-deals" element={<TodaysDealsPage />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} /> 
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
